module.exports = __webpack_public_path__ + "img/Menu-09.f8862b78.png";